import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FM120 / FM121 / FM123)
// ============================================================

export interface FM123 {
  fm123_01: string;   // 移轉單號 (FK)
  fm123_02: number;   // 明細項次 (FK)
  fm123_10: string;   // 尺寸碼1
  fm123_11: string;   // 尺寸碼2
  fm123_12: string;   // 尺寸代號
  fm123_13: number;   // 尺寸移轉數量
}

export interface FM121 {
  fm121_01: string;         // 移轉單號 (FK)
  fm121_02: number;         // 項次
  fm121_11: string;         // 出庫庫位
  fm121_12: string;         // 批號
  fm121_13: string;         // 產品代號1 (大類)
  fm121_14: string;         // 產品代號2 (細類)
  fm121_15: number;         // 移轉數量
  fm121_16: number;         // 單位換算
  fm121_17: string;         // 單位
  fm121_18: number;         // 移出單位成本
  fm121_181: number;        // 移轉金額
  fm121_19: string;         // 等級代號
  fm121_20: string;         // 板號
  fm121_21: string;         // 產品規格/顏色名稱
  fm121_22: string;         // 備用
  fm121_23: string;         // 顏色代號
  fm121_28: string;         // 移轉原因說明
  fm121_91: string;         // 修改人員
  fm121_92: string | null;  // 修改日期
  fm121_93: string;         // 建立人員
  sizes?: FM123[];
}

export interface FM120 {
  fm120_01: string;         // 移轉單號
  fm120_11: string | null;  // 移轉日期
  fm120_12: string;         // 入庫庫位
  fm120_13: string;         // 部門代號
  fm120_14: string;         // 備用
  fm120_15: string;         // 出庫單號
  fm120_16: number;         // 總項數
  fm120_17: string;         // 入單人員
  fm120_19: boolean;        // 旗標
  fm120_20: string;         // 調撥單號
  fm120_80: string;         // 核准狀態 ("P"=已核准)
  fm120_87: string;         // 核准人員
  fm120_88: string | null;  // 核准日期
  fm120_89: string;         // 備用碼
  fm120_91: string;         // 修改人員
  fm120_92: string | null;  // 修改日期
  fm120_93: string;         // 建立人員
  fm120_21: string;         // 備用代號
  fm120_23: string;         // 備註
  details?: FM121[];
}

export interface ListResponse {
  data: FM120[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwm202';

export const pwm202Api = {
  list: async (page = 1, pageSize = 20): Promise<ListResponse> => {
    const res = await apiClient.get(BASE, { params: { page, pageSize } });
    return res.data;
  },

  get: async (id: string): Promise<FM120> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  create: async (master: Partial<FM120>, details: Partial<FM121>[]): Promise<FM120> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FM120>, details: Partial<FM121>[]): Promise<FM120> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
